import { View, StyleSheet, ViewStyle, StyleProp } from 'react-native';
import { Text, Icon, theme } from '@socrait/react';

export function ErrorBox({
  header,
  text,
  containerStyle,
}: {
  header?: string;
  text?: string;
  containerStyle?: StyleProp<ViewStyle>;
}) {
  const headerText = header || 'Data unavailable!';
  const textText = text || 'Please try reloading this window.';

  return (
    <View style={[styles.container, containerStyle]}>
      <Icon type="error" fill={theme.colors.darkGray} />
      <Text style={[styles.text, styles.header]}>{headerText}</Text>
      <Text style={styles.text}>{textText}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    backgroundColor: theme.colors.gray,
    borderRadius: theme.borderRadius.large,
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing.xlarge * 2,
  },
  text: {
    color: theme.colors.darkGray,
    textAlign: 'center',
    fontSize: theme.fontSizes.small,
  },
  header: {
    fontSize: theme.fontSizes.large,
    fontWeight: theme.fontWeights.bold,
    marginBottom: theme.spacing.medium,
    marginTop: theme.spacing.xlarge,
  },
});
